import React, { Component } from "react"
import {
  InputCustom,
  SelectWithSearch,
  HttpError,
  TextArea
} from "../../components"
import * as ApiHelper from "../../ApiHelper"
import Util from "../../Util"
import { LoadModal } from "../modais"
import TermosDeApostilamentoModal from "../modais/TermosDeApostilamentoModal"
export default class RelatorioTermoDeApostilamentoForm extends Component {
  constructor() {
    super()
    this.onChangeData = this.onChangeData.bind(this)
    this.toggleReimpressaoModal = this.toggleReimpressaoModal.bind(this)
    this.hideReimpressaoModal = this.hideReimpressaoModal.bind(this)
    this.reset = this.reset.bind(this)
    this.handleErrors = this.handleErrors.bind(this)
    this.onChangeModificacoes = this.onChangeModificacoes.bind(this)
    this.onChangeSecretario = this.onChangeSecretario.bind(this)
    this.onChangeContrato = this.onChangeContrato.bind(this)
    this.onChangeClausula = this.onChangeClausula.bind(this)
    this.getContratos = this.getContratos.bind(this)
    this.sendForm = this.sendForm.bind(this)
    this.toggleLoadModal = this.toggleLoadModal.bind(this)
    this.state = {
      showLoad: false,
      data: "",
      secretario: "",
      modificacoes: "",
      clausula: "",
      contrato: "",
      contratos: [],
      formError: "",
      showReimpressaoModal: false
    }
  }
  reset() {
    this.setState({
      data: "",
      secretario: "",
      modificacoes: "",
      contrato: ""
    })
  }

  componentWillMount() {
    this.getContratos()
  }
  getContratos() {
    ApiHelper.getAllContratos((contratos, error) => {
      if (contratos) {
        var mapped = Util.mapContratos(contratos)
        mapped.shift()
        this.setState({
          contratos: mapped
        })
      } else {
        this.setState({
          httpError: error
        })
      }
    })
  }
  onChangeContrato(event) {
    this.setState({
      contrato: event,
      contrato_idError: ""
    })
  }
  onChangeModificacoes(e) {
    var newValue = e.target.value
    this.setState({
      modificacoes: newValue,
      modificacoesError: ""
    })
  }
  onChangeSecretario(e) {
    var newValue = e.target.value
    this.setState({
      secretario: newValue,
      secretarioError: ""
    })
  }
  onChangeData(value) {
    var newValue = value
    this.setState({
      data: newValue,
      dataError: ""
    })
  }
  onChangeClausula(event) {
    var newValue = event.target.value
    this.setState({
      clausula: newValue,
      clausulaError: ""
    })
  }

  sendForm(event) {
    event.preventDefault()
    var params = {
      tipo_relatorio: "Termo de apostilamento",
      contrato_id:
        this.state.contrato === undefined || this.state.contrato === null
          ? null
          : this.state.contrato.value,
      data: Util.dateOnly(this.state.data),
      endereco: this.state.endereco,
      secretario: this.state.secretario,
      modificacoes: this.state.modificacoes,
      clausula: this.state.clausula,
      cnpj: Util.unmaskField(this.state.cnpj)
    }
    this.toggleLoadModal()
    ApiHelper.getRelatorioWith(params, (relatorio, error) => {
      this.toggleLoadModal()
      if (relatorio) {
        var url = URL.createObjectURL(relatorio)
        var tempLink = document.createElement("a")
        tempLink.href = url
        tempLink.setAttribute("download", "Termo de apostilamento.pdf")
        document.body.appendChild(tempLink)
        tempLink.click()
        document.body.removeChild(tempLink)
        this.reset()
      } else {
        this.handleErrors(error)
        this.setState({
          formError: "Não existem baixas nesse período"
        })
      }
    })
  }
  handleErrors(errors) {
    var errorsJSON = JSON.parse(errors)
    var errorsValue = errorsJSON.errors
    var errorsState = {}
    for (var key in errorsValue) {
      errorsState[key + "Error"] = errorsValue[key][0]
    }
    this.setState(errorsState)
  }
  toggleLoadModal() {
    this.setState({
      showLoad: !this.state.showLoad
    })
  }
  toggleReimpressaoModal() {
    this.setState({
      showReimpressaoModal: !this.state.showReimpressaoModal
    })
  }
  hideReimpressaoModal() {
    this.setState({
      showReimpressaoModal: false
    })
  }
  render() {
    if (this.state.httpError) {
      return (
        <div className="row card" style={{ marginTop: 100 }}>
          <HttpError
            message={this.state.httpError.message}
            status={this.state.httpError.status}
          />
        </div>
      )
    }
    return (
      <div className="card card-content">
        <div className="row ">
          <TermosDeApostilamentoModal
            callBack={this.hideReimpressaoModal}
            show={this.state.showReimpressaoModal}
            onClose={this.toggleReimpressaoModal}
          />
          <LoadModal
            onClose={this.toggleLoadModal}
            show={this.state.showLoad}
          />
          <SelectWithSearch
            sizeClass="col-md-8"
            options={this.state.contratos}
            label="Contrato"
            error={this.state.contrato_idError}
            placeholder="Selecione um contrato ou deixe em branco para selecionar todos"
            onChange={this.onChangeContrato}
            value={this.state.contrato}
          />
          <div className="col-md-2">
            <button
              style={{ marginTop: "1.5rem" }}
              className="btn btn-primary"
              data-background-color="green"
              onClick={this.toggleReimpressaoModal}
            >
              Reimprimir termos
            </button>
          </div>
        </div>
        <div className="row">
          <InputCustom
            sizeClass="col-md-3"
            type="text"
            label="Nome do(a) secretário(a)"
            error={this.state.secretarioError}
            onChange={this.onChangeSecretario}
            value={this.state.secretario}
          />
          <InputCustom
            sizeClass="col-md-3"
            type="date"
            label="Data do termo"
            error={this.state.dataError}
            onChange={this.onChangeData}
            value={this.state.data}
          />
        </div>
        <div className="row">
          <TextArea
            onChange={this.onChangeModificacoes}
            sizeClass="col-md-12"
            label="Modificações realizadas"
            value={this.state.modificacoes}
            error={this.state.modificacoesError}
          />
        </div>
        <div className="row">
          <InputCustom
            sizeClass="col-md-12"
            type="text"
            label="Cláusula que ampara o termo (Ex. primeira, segunda, terceira, etc)"
            error={this.state.clausulaError}
            onChange={this.onChangeClausula}
            value={this.state.clausula}
          />
        </div>
        <div className="row">
          <span className="label label-primary">
            Verifique se o CNPJ e Endereço da unidade orçamentária estão
            devidamente cadastrados, ou o termo não será emitido
          </span>
        </div>
        <div className="row">
          <button
            onClick={this.sendForm}
            type="submit"
            className="btn btn-primary pull-left"
            data-background-color="as-blue"
          >
            Gerar
          </button>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/documentos/RelatorioTermoDeApostilamentoForm.js